export default {
  "A confirmation code has just been sent to you by message": "验证码已通过短信发送给您",
  "Already have an account": "已有账户",
  "Beyond this time, the reservation we retain will be available again for others": "超过此时间后，我们为您保留的预订将重新开放给其他人",
  "Book now": "立即预订",
  "Booking": "预订",
  "Booking information": "预订信息",
  "Booking start the first day at {startTime} and finish the last day at {endTime}": "预订从第一天的 {startTime} 开始，到最后一天的 {endTime} 结束",
  "Cancel booking": "取消预订",
  "Choose your date": "选择您的日期",
  "Confirm my phone number": "确认我的手机号码",
  "Confirm my registration": "确认我的报名",
  "Confirm my booking": "确认我的预订",
  "Confirm my registration and pay": "确认我的报名并支付",
  "Continue as guest": "以访客身份继续",
  "Continue to registration": "继续报名",
  "Create an account": "创建账户",
  "Dates": "日期",
  "End Date of Reservation": "预订结束日期",
  "Enlarge map": "放大地图",
  "Enter your code here to confirm your registration": "请在此输入您的验证码以确认报名",
  "I accept the Terms and conditions of registration": "我接受注册条款和条件",
  "I accept the terms of service and confirm that I have read the privacy policy": "我接受服务条款，并确认已阅读隐私政策",
  "Loading…": "加载中…",
  "Location": "位置",
  "More information": "更多信息",
  "No slots available": "没有可用名额",
  "Processing booking…": "正在处理预订…",
  "Processing payment…": "正在处理支付…",
  "Product": "产品",
  "Recording payment…": "正在记录支付…",
  "Reduce map": "缩小地图",
  "Remaining time": "剩余时间",
  "Required fields": "必填项",
  "Reserving a product is mandatory for registration": "报名必须预订一件产品",
  "Retrieving available slots": "正在获取可用名额",
  "Saving registration…": "正在保存报名…",
  "Select size first": "请先选择尺寸",
  "Select stage first": "请先选择场次",
  "Select your options and dates to book": "请选择您的选项和日期以进行预订",
  "Size": "尺寸",
  "Slot": "名额",
  "Stage": "场次",
  "Store": "门店",
  "Start Date of Reservation": "预订开始日期",
  "View privacy policy": "查看隐私政策",
  "View terms and conditions": "查看条款和条件",
  "You do not want to create an account": "您不想创建账户",
  "The selected product has been set aside for you. You have {minutes} minutes to complete the process by providing your personal information.": "所选产品已为您保留。您有 {minutes} 分钟时间，通过在下一页填写您的个人信息来完成流程。",
  "Your reservation is in progress!": "您的预订正在处理中！",
  "not available": "不可用",
  "remaining place": "剩余名额|剩余名额",
  "see availability": "查看可用情况",
  "Email Address": "电子邮箱",
  "Phone": "电话",
  "Birthdate": "出生日期",
  "ProductTypes": "产品类型",
  "Sizes": "尺寸",
  "Filter": "筛选",
  "Select a date": "选择日期",
  "Give us your opinion": "告诉我们您的想法",
  "Thank you for your review!": "感谢您的评价！",
  "You can also review these products": "您还可以评价这些产品",
  "Undo": "撤销",
  "Redo": "重做",
  "Bold": "加粗",
  "Italic": "斜体",
  "Strikethrough": "删除线",
  "Paragraph": "段落",
  "Add Link": "添加链接",
  "Remove Link": "移除链接",
  "Headings": "标题",
  "Heading 2": "标题 2",
  "Heading 3": "标题 3",
  "Heading 4": "标题 4",
  "Heading 5": "标题 5",
  "Heading 6": "标题 6",
  "Bullet List": "项目符号列表",
  "Numbered List": "编号列表",
  "Clear Formatting": "清除格式",
  "Overall Rating": "总体评分",
  "Review title": "评价标题",
  "Summarize your impression on the product": "总结您对该产品的印象",
  "Your detailed product review": "您对该产品的详细评价",
  "50 characters minimum": "至少 50 个字符",
  "What was your impression of the product while testing? What did you like or dislike about the product? What conditions where present while testing the product?": "您在测试期间对该产品的印象如何？您喜欢或不喜欢该产品的哪些方面？测试该产品时的条件如何？",
  "50 characters (minimum)": "50 个字符（最少）",
  "Comments": "评论",
  "Comments on the reception, the organization, the advice on the product…": "关于接待、组织安排、产品建议的评论…",
  "Would you recommend this product to a friend?": "您会向朋友推荐这款产品吗？",
  "Would you be ready to buy this product?": "您愿意购买这款产品吗？",
  "First name or pseudo": "名字或昵称",
  "Your name / nickname is published with your review": "您的姓名/昵称将与您的评价一同公布",
  "I have read and I accept the terms and conditions": "我已阅读并接受条款和条件",
  "of publication of the reviews": "评价发布的",
  "and": "以及",
  "the privacy policy": "隐私政策",
  "Post Review": "发布评价",
  "Very bad": "非常差",
  "Bad": "差",
  "Average": "一般",
  "Good": "好",
  "Great!": "非常好！",
  "Image caption": "图片说明",
  "No": "否",
  "Yes": "是",
  "Booking dates": "预订日期",
  "Registration": "注册",
  "Status": "状态",
  "Created at": "创建于",
  "Actions": "操作",
  "Cancel": "取消",
  "This site is protected by reCAPTCHA.": "本网站受 reCAPTCHA 保护。",
  "Google Privacy Policy": "Google 隐私权政策",
  "Google Terms of Service": "Google 服务条款",
};
